import ReusableListTitle from "../UI/ReusableListTitle";

export default function EmployeeTitle() {
  return <ReusableListTitle />;
}
